// ═══════════════════════════════════════════════════════════
// FOIA — GAB Table Keys  (real IDs — do not edit manually)
// App ID: uyw6d4mmv
// Generated by scripts/create_gab_tables.py
// ═══════════════════════════════════════════════════════════

export const TABLES = {
  requests:              'pa1l6s8qe',
  requesters:            '6t5tb8mpk',
  documents:             'fz6kyugqq',
  redactions:            'kequcwjud',
  tasks:                 'ey1oawa36',
  workflows:             '5qoo3beh5',
  workflowSteps:         'm9h1j8vky',
  correspondence:        'z51jczl9a',
  corrTemplates:         'jld2em3gj',
  invoices:              'i1sy9y14o',
  invoiceItems:          '6jd99t5g3',
  jurisdictions:         '1m4h43xex',
  departments:           'hbcgdxr5b',
  exemptionCodes:        'cvnxau4w9',
  holidays:              'hm2jnyjab',
  clockPauses:           'l62dlddrj',
  publicUsers:           'isfc4m7gb',
  auditLog:              'a5yjfudpv',
  uploadTokens:          's06iuj2mh',
  libraryDocuments:      'tva18zg4i',
} as const;

export type TableKey = keyof typeof TABLES;
